import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IServiceRequestResponseData,
  IServiceRequestState,
  IRequestItem,
  IPrice,
} from "../@types/requests";
import { IApiResponse } from "../@types/api-response";

const initialState: IServiceRequestState = {
  requests: [],
  request: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingId: null,
  priceLoading: false,
};

export const serviceRequest = createSlice({
  name: "service-request",
  initialState,
  reducers: {
    setServiceRequests: (
      state,
      action: PayloadAction<IApiResponse<IServiceRequestResponseData>>,
    ) => {
      const payload = action.payload.data;

      state.requests = payload.data;
      state.limit = payload.limit;
      state.offset = payload.offset;
      state.total = payload.total;
    },

    setServiceRequest: (state, action: PayloadAction<IRequestItem | null>) => {
      state.request = action.payload;
    },

    setRequestOffset: (state, action: PayloadAction<number>) => {
      state.offset = Math.max(0, action.payload);
    },

    createRequestPrice: (state, action: PayloadAction<IPrice>) => {
      if (!state.request) return;

      const existingPrices = state.request.price ?? [];
      state.request.price = [action.payload, ...existingPrices];
    },
    updateRequestPrice: (state, action: PayloadAction<IPrice>) => {
      if (!state.request) return;

      state.request.price = (state.request.price ?? []).map((priceItem) =>
        priceItem.id === action.payload.id
          ? { ...priceItem, ...action.payload }
          : priceItem,
      );
    },

    setLoadingTrue: (state) => {
      state.loading = true;
    },

    setLoadingFalse: (state) => {
      state.loading = false;
    },

    setPriceLoadingTrue: (state) => {
      state.priceLoading = true;
    },

    setPriceLoadingFalse: (state) => {
      state.priceLoading = false;
    },
  },
});

export const {
  setServiceRequests,
  setServiceRequest,
  setRequestOffset,
  createRequestPrice,
  updateRequestPrice,
  setLoadingTrue,
  setLoadingFalse,
  setPriceLoadingTrue,
  setPriceLoadingFalse,
} = serviceRequest.actions;

export default serviceRequest.reducer;
